import styled from 'styled-components';

const ProductReviewFormSectionStyle = styled.div`
	--reviewFormSectionMTop: var(--sp7x);
	--reviewFormColMTop: var(--sp3x);
	--reviewBtnColMTop: var(--sp4x);

	margin-top: var(--reviewFormSectionMTop);

	.form-review-title {
		margin-bottom: var(--sp2x);
	}

	.ant-rate {
		font-size: var(--h2);
	}

	.ant-form-item-label {
		margin-bottom: var(--sp1x);
		font-size: var(--h3);
		font-family: var(--futura);
		font-weight: 500 !important;
	}

	.review-form-col {
		margin-top: var(--reviewFormColMTop);
	}

	.review-btn-col {
		margin-top: var(--reviewBtnColMTop);
	}

	.success-text {
		margin-top: var(--reviewBtnColMTop);
	}

	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--reviewFormSectionMTop: var(--sp6x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--reviewFormSectionMTop: var(--sp6x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--reviewFormSectionMTop: var(--sp5x);
		--reviewFormColMTop: var(--sp2x);
		--reviewBtnColMTop: var(--sp3x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--reviewFormSectionMTop: var(--sp5x);
		--reviewFormColMTop: var(--sp2x);
		--reviewBtnColMTop: var(--sp3x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--reviewFormSectionMTop: var(--sp5x);
		--reviewFormColMTop: var(--sp2x);
		--reviewBtnColMTop: var(--sp3x);
	}
`;

export default ProductReviewFormSectionStyle;
